import * as React from 'react';
import { clsx } from 'clsx';
import { isSameMonth, isSameDay, isAfter, isBefore, startOfMonth, startOfDay } from 'date-fns';
import { format } from '../../../../../internal/utils/date';
import { generateDataTestId } from '../../../../../internal/utils';
import * as styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WEEK_DAYS_ARRAY = [1, 2, 3, 4, 5, 6, 0];
export function DayPicker(props) {
  var selected = props.selected,
    onChange = props.onChange,
    month = props.month,
    dataTestId = props.dataTestId;
  var now = new Date();
  var min = props.min && startOfDay(props.min);
  var max = props.max && startOfDay(props.max);
  var currentMonth = React.useMemo(function () {
    if (min && isBefore(month, min)) {
      return min;
    }
    if (max && isAfter(month, max)) {
      return max;
    }
    return month;
  }, [month, min, max]);
  var dates = React.useMemo(function () {
    var acc = [];
    var nextDate = startOfMonth(currentMonth);
    var day = nextDate.getDay();
    var prevMonthDays = WEEK_DAYS_ARRAY.indexOf(day);
    nextDate.setDate(nextDate.getDate() - prevMonthDays);

    // Цикл на 6 недель, для того чтобы всегда было равное количество недель
    for (var i = 0; i < 7 * 6; i++) {
      acc.push(new Date(nextDate));
      nextDate.setDate(nextDate.getDate() + 1);
    }
    return acc;
  }, [currentMonth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['week-days'],
      children: dates.slice(0, 7).map(function (date, i) {
        var dateFormatted = format('EEEEEE', date);
        return /*#__PURE__*/_jsx("div", {
          className: styles['week-day'],
          "aria-hidden": "true",
          "data-testid": generateDataTestId(dataTestId, [dateFormatted]),
          children: dateFormatted
        }, i);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['dates'],
      children: dates.map(function (date, i) {
        var n = date.getDate();
        return /*#__PURE__*/_jsx("button", {
          className: clsx(styles['date'], selected && isSameDay(date, selected) && styles['selected'], isSameDay(date, now) && styles['today'], !isSameMonth(date, currentMonth) && styles['other-month']),
          onClick: function onClick() {
            onChange(new Date(date));
          },
          "aria-label": format('P', date),
          disabled: isDisabled(date, min, max),
          "data-testid": generateDataTestId(dataTestId, ["".concat(n)]),
          children: n
        }, i);
      })
    })]
  });
}
function isDisabled(date, min, max) {
  return !!(min && isBefore(date, min) || max && isAfter(date, max));
}